import Column from './src/table-column';
import Table from './src/table';



export { Table, Column };



// WEBPACK FOOTER //
// ./src/components/table1/index.js